import React from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Manifesto } from "../components/site/Manifesto";
import { Services } from "../components/site/Services";
import { Promotions } from "../components/site/Promotions";
import { Gallery } from "../components/site/Gallery";
import { Testimonials } from "../components/site/Testimonials";
import { Booking } from "../components/site/Booking";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#f9f6f0] text-[#2c1e16]">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Promotions />
        <Gallery />
        <Testimonials />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
